import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";

import React, { useEffect, useState } from "react";
import axios from "axios";
import { getBaseUrl } from "../../utils";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
const LoginOne = ({ nextStep, handleFormData, values }) => {
    // const handleGoogleLogin = () => {
    //     nextStep();
    // };
    const baseUrl = getBaseUrl();

    const navigate = useNavigate();
    const handlePhoneLogin = () => {
        nextStep();
    };


    const handleSuccess = async (credentialResponse) => {
        const idToken = credentialResponse && credentialResponse.credential;
        if (!idToken) {
            alert("Google sign-in failed. Please try again.");
            return;
        }

        let googleEmail = "";
        try {
            googleEmail = jwtDecode(idToken).email || "";
        } catch (e) {
            // Not fatal: the backend verifies the token and reads the email itself.
        }

        try {
            // The backend verifies the Google ID token, finds or creates the user
            // and returns our own login token (same as the mobile app).
            const response = await axios.post(baseUrl + "user_api/googleAuthentication", {
                idToken: idToken,
                email: googleEmail,
                deviceType: "WEB",
                deviceID: "web",
                deviceToken: "",
            });

            if (response.data && response.data.status && response.data.token) {
                localStorage.setItem("userToken", response.data.token);
                const results = response.data.results || {};
                if (!results.name) {
                    // New user (or profile not finished): prefill email on the signup form.
                    if (googleEmail) localStorage.setItem("googleEmail", googleEmail);
                    navigate("/signup");
                } else {
                    navigate("/dashboard");
                }
            } else {
                alert((response.data && response.data.message) || "Google sign-in failed. Please try again.");
            }
        } catch (error) {
            console.error("Google login error:", error);
            alert("Could not sign in with Google. Please try again later.");
        }
    };
    const handleError = () => {
        alert("Google sign-in was cancelled or failed. Please try again.");
    };


    return (
        <div>
            <section>

                <Link to='/'>
                    <button className="bg-black px-8 py-2.5 shadow-lg fixed top-4 right-4 rounded-lg text-white">
                        <h1>Go To Home</h1>
                    </button>
                </Link>


                <div className="container-xxl pl-0 pt-[20px]">
                    <div className="row">
                        <div className="col-12 flex items-center justify-center">
                            <div className="md:w-[900px] w-full flex h-[541px]">
                                <div className="w-full md:block hidden">
                                    <img
                                        src="/assates/Login.png"
                                        className="h-full w-full"
                                    />
                                </div>
                                <div className="md:w-[50%] w-full md:shadow-xl rounded-br-xl rounded-tr-xl">
                                    <div className="md:p-[50px]">
                                        <div className="flex items-center justify-center">
                                             <img src="/assates/Logo__newimage-removebg-preview.png" className="w-[200px] rounded-lg" />
                                        </div>
                                        <h1 className="text-center Header__text font-[700]">
                                            Welcome Back!
                                        </h1>
                                        <p className="text-center Paragraph__etxt font-[500] pb-12">
                                            Please log in to access your
                                            account.
                                        </p>
                                        {/* <button
                                            className="w-full flex items-center gap-2 Paragraph__etxt font-[500] h-[50px] justify-center choose_qulifation_section rounded-lg"
                                        >
                                            <img
                                                src="/assates/google.png"
                                                alt="google"
                                            />
                                            <label>Continue with Google</label>
                                        </button> */}

                                        <GoogleOAuthProvider clientId="19877150229-gdj2jd9104lmvupnsni3pqrkbu39pc1g.apps.googleusercontent.com">
                                            <div
                                                className="w-full flex items-center gap-2 Paragraph__etxt font-[500] h-[50px] justify-center choose_qulifation_section rounded-lg"
                                            >
                                                <GoogleLogin onSuccess={handleSuccess} onError={handleError} />
                                            </div>
                                        </GoogleOAuthProvider>

                                        <div className="flex items-center gap-3 mt-4 mb-4 mobile__Section">
                                            <div
                                                className="bg-[#28282B] w-[200px]"
                                                style={{ height: "0.4px" }}
                                            />
                                            <h5 className="Paragraph__etxt font-[600]">
                                                Or
                                            </h5>
                                            <div
                                                className="bg-[#28282B] w-[200px]"
                                                style={{ height: "0.4px" }}
                                            />
                                        </div>
                                        <button
                                            className="md:mt-0 mt-6 w-full flex items-center bg-[#28282B] text-white gap-2 Paragraph__etxt font-[500] h-[50px] justify-center choose_qulifation_section rounded-lg"
                                            onClick={handlePhoneLogin}
                                        >
                                            <i className="ri-phone-fill"></i>
                                            <label>Continue with Phone</label>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default LoginOne;
